import { useEffect, useState } from 'react';
import '../styles/banner.css';

interface BannerProps {
  images: string[];
  interval?: number;
}

const Banner: React.FC<BannerProps> = ({ images, interval = 5000 }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const hasValidImages = images.length > 0;
  const sanitizedInterval = Math.max(interval || 5000, 1000);

  useEffect(() => {
    if (!hasValidImages) return;

    const imageChangeInterval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
    }, sanitizedInterval);

    return () => clearInterval(imageChangeInterval);
  }, [hasValidImages, images, sanitizedInterval]);

  if (!hasValidImages) {
    return <div className='banner-container'>No images available</div>;
  }

  return (
    <div className='banner-container'>
      <div className='banner-images-wrapper' style={{ transform: `translateX(-${currentImageIndex * 100}%)` }}>
        {images.map((image, index) => (
          <img key={image} src={image} alt={`banner-${index}`} className='banner-image' />
        ))}
      </div>
    </div>
  );
};

export default Banner;
